import { tns } from 'tiny-slider/src/tiny-slider.js';

export function threeImageCarousel() {
    const slider = tns({
        container: '.js-three-image-carousel',
        gutter: 0,
        items: 1,
        nav: false,
        controls: true,
        loop: true,
        autoplay: true,
        autoplayButton: false,
        controlsContainer: '.js-controls-container',
        responsive: {
          800: {
            items: 3,
            gutter: 30,
          },
        },
      });
      slider;
}


// WEBPACK FOOTER //
// ./scripts/partials/three-image-carousel.js